import React , { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
// import { Compass } from "@patternfly/react-core";
import { EducationDirectionsProvider } from "apps/school-site/features/education-direction/context/EducationDirectionsContext";

import SchoolHeader from "./header/SchoolHeader";
import SchoolMegaMenu from "./header/navigation/SchoolMegaMenu";
import SchoolMain from "./SchoolMain";
import SchoolHeaderTop from "./header/top/SchoolHeaderTop";
import NavigationProvider from "./header/navigation/context/NavigationProvider";
import SchoolMobileDrawer from "./header/navigation/mobile/SchoolMobileDrawer";
import BackToTopButton from "../../../shared/components/BackToTop/BackToTopButton";

const SchoolLayout = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", onScroll);
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, []);


  return (
    <>
      <div className="school-site">
        <EducationDirectionsProvider>
          <NavigationProvider>
            <SchoolHeaderTop />
              <div className={`school-header-sticky ${isScrolled ? "is-scrolled" : ""}`}>
                  <SchoolHeader />
                  <SchoolMegaMenu />
              </div>
              <div className="school-page">
                <SchoolMobileDrawer />

                <SchoolMain>
                    <Outlet />
                </SchoolMain>
            </div>
            <BackToTopButton />
          </NavigationProvider>
        </EducationDirectionsProvider>
      </div>
    </>
  );
};

export default SchoolLayout;
